<template>
  <v-alert
  	v-bind="$attrs" 
	  v-on="$listeners"
  >
    <span class="alertMessage">{{ textAlert }}</span>
  </v-alert>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    textAlert: {
      type: String,
      default: () => "I'm an Alert Example",
    },
  },
  methods: {
  },
  watch: {
  },
}
</script>

<style>

</style>
